import styled from "styled-components";
import { theme } from "../../theme";

export const StyledFinishedExamsCardWrapper = styled.div`
    background-color: ${theme.colors.mainWhite};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
    border-radius: 1.1rem;
    margin-bottom: 4.2rem;
`